import BaseService from 'services/BaseService';

class UserService extends BaseService {
  getInfo() {
    return this.get('/api/userInfo');
  }

  register(userData, venueRegisters) {
    return this.post('auth/register', {
      venueRegisters,
      ...userData
    });
  }

  sendRestorePasswordEmail(email) {
    return this.post('/api/forgotpassword', {
      Email: email
    });
  }

  getQuestion(token) {
    return this.get(`/api/forgotpassword/${token}/question`);
  }

  restorePassword(token, answer, newPassword) {
    return this.post(`/api/forgotpassword/${token}/restore`, {
      Answer: answer /* Answer to the secret question. */,
      Password: newPassword /* New password for the user. */
    });
  }

  changePassword(currentPassword, newPassword) {
    return this.post('/api/changepassword', { CurrentPassword: currentPassword, NewPassword: newPassword });
  }

  getUserDetails() {
    return this.get('/api/userdetails/get');
  }

  saveUserDetails(userDetails) {
    return this.post('/api/userdetails/set', userDetails);
  }
}

export default UserService;



// WEBPACK FOOTER //
// ./src/services/UserService.js